import React, { useEffect, useState } from "react"
import { useAppDispatch } from "../../../store"
import { setCurrentPage } from "../../../store/auth/authReducer"
import { Navigate, useLocation } from "react-router-dom"
import axios from "axios"
import Box from "@mui/material/Box"
import TextField from "@mui/material/TextField"
import Button from "@mui/material/Button"
import Snackbar from "@mui/material/Snackbar"
import Alert from "@mui/material/Alert"
import Select from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import FormControl from "@mui/material/FormControl"
import InputLabel from "@mui/material/InputLabel"
import { logOut } from "../../../utils/logOut"
import TranslatedText from "../../../utils/Translate"
import { useSnackbar } from "../../../utils/SnackbarContext"

export default function SynthAudioFragment() {
    const dispatch = useAppDispatch()
    const location = useLocation()
    const [openSnackbar, setOpenSnackbar] = useState(false)
    const [snackbarType, setSnackbarType] = useState("")
    //get URL params
    const params = new URLSearchParams(location.search);
    const id = params.get('id');
    const type: string | null = params.get('type')

    useEffect(() => {
        dispatch(setCurrentPage(`Edit synthesized audio fragment`))
    }, [dispatch]);

    const { showSnackbar } = useSnackbar();

    //handle close snackbar
    const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };
    //get partner by ID
    async function fetchData(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/synthesizedspeech/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            if (response.data !== null) {
                setAudioFragmentData(response.data[0])
            }

            console.log(response.data[0]);

        } catch (error: any) {
            console.log(error);
            if (error.code === "ERR_BAD_REQUEST") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //edit partner
    async function putData(data: object = {}) {
        try {
            const response = await axios.put(`https://cardgarantsales.com/restapi/synthesizedspeech/${id}`, {
                ...data
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })

            setSnackbarType('success')
            setOpenSnackbar(true)
        } catch (error: any) {
            setSnackbarType('error')
            setOpenSnackbar(true)
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    const [audioFragmentData, setAudioFragmentData] = useState<any>([])
    //If url params contains type = edit, get audio fragment data to fill text fields
    useEffect(() => {
        fetchData()
    }, [])

    return (
        <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
            <Box sx={{ width: 440, display: "flex", mb: 2, flexWrap: "wrap", gap: 2 }}>
                {/* <TextField sx={{ width: '100%' }} onChange={(e) => setAudioFragmentData({ ...audioFragmentData, text: e.target.value !== '' ? e.target.value : '' })} value={audioFragmentData.text || ''} variant="outlined" size="small" label={<TranslatedText text={'Text'} />} /> */}
                <TextField rows={2}  onChange={(e) => setAudioFragmentData({ ...audioFragmentData, text: e.target.value !== '' ? e.target.value : '' })} value={audioFragmentData.text || ''} multiline sx={{ width: "100%", '& textarea': { resize: 'vertical' } }} variant="outlined" size="small" label={<TranslatedText text={'Text'} />} />
                <Button onClick={() => putData(audioFragmentData)} variant="contained" sx={{ width: "100%" }}><TranslatedText text={'Save'} /></Button>
            </Box>
            <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleClose}>
                {snackbarType === 'error' ?
                    <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
                        <TranslatedText text={'Saving error'} />
                    </Alert> :
                    <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
                        <TranslatedText text={'Successfully saved'} />
                    </Alert>}
            </Snackbar>
        </Box >
    )
}